import OptionGenerator from '../Generic/Options';

export default OptionGenerator(
    'sensortypes',
    () => true,
    () => [],
    (props: any, items: any[]) => {
        const { sensorTypeChangeHandler, handleChange } = props;
        let ret = {
            ...props,
            onChange: (e: any, data: any) => {
                if (props.sensorTypeChangeHandler) {
                    let currentSensorTypes = items.filter(item => item.typedId === data.value);
                    let currentSensorType = currentSensorTypes && currentSensorTypes.length > 0 ?
                        currentSensorTypes[0]
                        : undefined;
                    sensorTypeChangeHandler(e, {...data, value: currentSensorType});
                }
                if (handleChange) {
                    handleChange(e, data);
                }
            }
        };
        delete ret.handleChange;
        delete ret.sensorTypeChangeHandler;
        return ret;
    }
);


// WEBPACK FOOTER //
// ./src/container/SensorType/SensorTypeOptions.tsx